import type { FC } from "react";
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  Stack,
  Tooltip,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useAppDispatch } from "src/app/reduxCustomHooks";
import { logoutAction } from "src/app/slices/authSlice";
import { toast } from "react-toastify";
import NotificationMenu from "./menus/NotificationMenu";
import ProfileMenu from "./menus/ProfileMenu";
import { api } from "src/app/services/api.generated";
import { api as secondApi } from "src/app/services/api";
import LogoutIcon from '@mui/icons-material/Logout';

type NavbarPropsType = {
  handleDrawerToggle: () => void;
};

const Navbar: FC<NavbarPropsType> = ({ handleDrawerToggle }) => {
  const dispatch = useAppDispatch();

  const logoutHandler = () => {
    dispatch(api.util.resetApiState());
    dispatch(secondApi.util.resetApiState());
    dispatch(logoutAction());
    window.location.reload();
    toast.success("شما با موفقیت خارج شدید");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        width: "100%",
        zIndex: 1201,
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2 }}
        >
          <MenuIcon />
        </IconButton>
        <Typography sx={{ display: { xs: "none", sm: "block" } }}>
          مدیریت فیلم ناب
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="start"
          sx={{ ml: "auto" }}
        >
          <ProfileMenu />
          {/* <NotificationMenu /> */}
          <Tooltip title="خروج از سامانه" arrow>
            <IconButton color="inherit" onClick={logoutHandler}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
